<template>
    <div class="pt-xl-1 bg-gray2 d-xl-flex">
        <div class="row px-1">
            <h4 class="col-12 col-xl-3 px-1 mb-0 pe-xl-0 ps-xl-2 py-xl-2">
                {{ title }}
            </h4>
            <ob1-picture
                class="col-12 col-xl-6 ps-1 pe-0 py-0 justify-content-center"
                :visual="picture"
                css-classes="device-value-help-img px-xl-1"
            />
            <p class="col-12 col-xl-3 px-1 mb-0 ps-xl-0 pe-xl-2 py-xl-2 align-self-lg-end lead">
                <strong>{{ text }}</strong>
            </p>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        title: {
            type: String,
            required: true
        },
        text: {
            type: String,
            required: true
        },
        pictureDto: {
            type: Object,
            required: true
        }
    },
    computed: {
        picture() {
            return {
                alt: this.pictureDto.alt,
                src: this.pictureDto.smallSrcSet,
                xsSrcSet: this.pictureDto.smallSrcSet,
                smallSrcSet: this.pictureDto.smallSrcSet,
                mediumSrcSet: this.pictureDto.smallSrcSet,
                largeSrcSet: this.pictureDto.smallSrcSet,
                xlSrcSet: this.pictureDto.largeSrcSet,
                xxlSrcSet: this.pictureDto.largeSrcSet,
            }
        }
    }
}
</script>

<style lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.device-value-help-img {
    @media (min-width: #{map-get($grid-breakpoints, xs)}) {
        max-width: px-to-rem(330);
    }
    @media (min-width: #{map-get($grid-breakpoints, md)}) {
        max-height: px-to-rem(240);
    }
    @media (min-width: #{map-get($grid-breakpoints, xl)}) {
        max-height: 100%;
        max-width: 100%;
    }
}
</style>
